<template>
    <Datatable
        name="Licenses"
        @search="fetchData"
        :pagination.sync="pagination"
        :loading="loading"
        :searchClass="group ? 'd-none' : null"
        hover
        scrollX
    >
        <template v-slot:filters v-if="!group">
            <Dropdown
                class="me-1 mb-1"
                :color="isFilterByTypeActive ? 'success' : 'secondary'"
                title="Filter by type"
                small
            >
                <li v-for="(type, technical_name) in licenseTypes" :key="technical_name">
                    <a
                        href="#"
                        class="dropdown-item text-xs"
                        :class="licenseType === technical_name ? 'bg-primary text-white' : 'bg-white'"
                        @click.prevent="filterByLicenseType(technical_name)"
                        >{{ type.name }}</a
                    >
                </li>
            </Dropdown>
        </template>
        <template v-slot:thead>
            <tr>
                <th>Reference</th>
                <th>Type</th>
                <th>Paid by</th>
                <th>Paid for</th>
                <th>Created at</th>
                <th>Used at</th>
                <th>Status</th>
                <th></th>
            </tr>
        </template>
        <tr
            v-for="license in licenses"
            class="cursor-pointer"
            @click="openLicense(license)"
            :key="license.id"
            valign="middle"
        >
            <td>{{ license.reference }}</td>
            <td>{{ license.license_type }}</td>
            <td>{{ license.paid_by && license.paid_by.name ? license.paid_by.name : license.paid_by_id }}</td>
            <td>{{ license.paid_for && license.paid_for.name ? license.paid_for.name : license.paid_for_id }}</td>
            <td>{{ license.created_at | formatDate }}</td>
            <td>{{ license.used_at | formatDate }}</td>
            <td><LicenseStatus :license="license" /></td>
            <td class="text-right"><Icon icon="angle-right" /></td>
        </tr>
    </Datatable>
</template>

<script>
    import { Datatable, Alerts, Dropdown } from '@tech_hexeko/design-system'
    import Modals from '@tech_hexeko/design-system/src/mixins/Modals'
    import Helpers from '@tech_hexeko/hexeko-api-classes/Helpers'
    import { formatError } from '@/plugins/errors.js'
    import LicenseStatus from './status'
    import types from './types'

    export default {
        name: 'Licenses',
        mixins: [Modals],
        components: {
            Datatable,
            LicenseStatus,
            Dropdown,
        },
        props: {
            group: {
                type: Number,
                default: null,
            },
            params: {
                type: Object,
                default: () => ({}),
            },
            user: {
                type: Number,
                default: null,
            },
        },
        data() {
            return {
                loading: true,
                pagination: {
                    current_page: 1,
                },
                licenses: [],
                licenseTypes: types,
                licenseType: null,
            }
        },
        computed: {
            isFilterByTypeActive() {
                return !!this.licenseType
            },
        },
        methods: {
            async fetchData(search) {
                try {
                    this.loading = true
                    const innerParams = {
                        includes: ['paid_for', 'paid_by'],
                        page: this.pagination?.current_page,
                    }
                    if (!this.group) {
                        innerParams.search = search
                        innerParams.license_type = this.licenseType
                    }
                    const payload = this.mergeParams(innerParams)
                    let response = null
                    if (this.user) {
                        response = await this.$api.users.getLicenses(this.user, payload)
                    } else if (this.group) {
                        response = await this.$api.groups.getGroupLicenses(this.group, payload)
                    }
                    if (!response) throw formatError()
                    this.licenses = response.data
                    this.pagination = response.meta?.pagination
                } catch (error) {
                    const errorTxt = formatError(error)
                    Alerts.notificationError(errorTxt)
                } finally {
                    this.loading = false
                }
            },
            mergeParams(params) {
                return Helpers.cleanObject(Object.assign(this.params, params))
            },
            openLicense(license) {
                const panel = this.openPanel('LicensePanel', license.id)
                panel.promise.then((result) => {
                    if (result && result.refresh) {
                        this.fetchData(this.search)
                    }
                })
            },
            filterByLicenseType(licenseType) {
                this.licenseType = this.licenseType === licenseType ? null : licenseType
                this.pagination.current_page = 1
                this.fetchData(this.search)
            },
        },
        mounted() {
            this.fetchData()
        },
    }
</script>
